export enum MimeType {
  TEXT = 'text',
  PLAIN_TEXT = 'text/plain',
  PDF = 'application/pdf',
  XML = 'application/xml',
  MP4 = 'video/mp4',
  ZIP = 'application/zip',
  BINARY = 'application/binary'
}
